import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "src/store/store";
import type { PendingVerificationContext } from "src/utils/pendingVerification";

interface VerificationState {
    pending: PendingVerificationContext | null;
}

const initialState: VerificationState = { pending: null };

const verificationSlice = createSlice({
    name: "verification",
    initialState,
    reducers: {
        setPendingVerification(state, action: PayloadAction<PendingVerificationContext>) {
            state.pending = action.payload;
        },
        clearPendingVerificationState(state) {
            state.pending = null;
        },
    },
});

export const { setPendingVerification, clearPendingVerificationState } = verificationSlice.actions;
export const pendingVerificationSelector = (state: RootState) => state.verification.pending;
export default verificationSlice.reducer;
